import { useMemo, useState } from 'react';

import { themesFromApi } from 'views/V2/Medallion/helper/utilities';

import { useFetchAllThemesQuery } from 'redux/slices/themesApi';

import { isDarkColor } from './utilities';

// The default theme's logo. Its signed URL expires after 5 minutes, so a failed
// image refetches the list once before falling back to the initial tile.
export default function useCustomerLogo() {
    const { data, fulfilledTimeStamp, refetch } = useFetchAllThemesQuery();
    const [hasRetried, setHasRetried] = useState(false);
    const [hasFailed, setHasFailed] = useState(false);

    const defaultTheme = useMemo(
        () => (data ? themesFromApi(data).find((theme) => theme.isDefault) : null),
        [data]
    );

    const handleError = () => {
        if (hasRetried) {
            setHasFailed(true);
        } else {
            setHasRetried(true);
            refetch();
        }
    };

    const navbarColor = defaultTheme?.config?.navbarColor;

    return {
        logoUrl: hasFailed ? null : defaultTheme?.logoUrl,
        // Remounts the image after a refetch, even when the URL is unchanged.
        logoKey: fulfilledTimeStamp,
        // A logo made for a dark header needs that header colour behind it.
        background: isDarkColor(navbarColor) ? navbarColor : undefined,
        handleError,
    };
}
